export default __webpack_public_path__ + "static/test_2_1_ru-bf152e042bb3255077843b9692363345.png";